<template>
  <div>
    <div class="account-bar">
      <b-container
        class="d-flex account-bar__container">
        <router-link
          tag="div"
          class="account-bar__link no-active"
          to="/">
          <div
            class="account-bar__tab">
            <font-awesome-icon
              class="mr-2"
              :icon="['fas', 'arrow-left']" />
            Back Home
          </div>
        </router-link>
        <router-link
          tag="div"
          class="account-bar__link"
          to="/manage"
          v-if="isAdmin">
          <div
            class="account-bar__tab">
            Admin
          </div>
        </router-link>
        <router-link
          tag="div"
          class="account-bar__link"
          to="/account/listings">
          <div
            class="account-bar__tab">
            My Listings
          </div>
        </router-link>
        <router-link
          tag="div"
          class="account-bar__link"
          to="/account/purchases">
          <div
            class="account-bar__tab">
            Buying and Selling
            <b-badge
              v-if="unreadCount > 0"
              pill
              variant="light"
              class="ml-2">
              {{ unreadCount }}
            </b-badge>
          </div>
        </router-link>
        <router-link
          tag="div"
          class="account-bar__link"
          to="/account/favorites">
          <div
            class="account-bar__tab">
            Favorites
            <b-badge
              v-if="unreadCount > 0"
              pill
              variant="light"
              class="ml-2">
              {{ favoritesCount }}
            </b-badge>
          </div>
        </router-link>
        <router-link
          tag="div"
          class="account-bar__link"
          to="/account/billing-history">
          <div
            class="account-bar__tab">
            Billing History
          </div>
        </router-link>
        <router-link
          tag="div"
          class="account-bar__link"
          to="/account/profile">
          <div
            class="account-bar__tab">
            Profile
          </div>
        </router-link>
        <router-link
          tag="div"
          class="account-bar__link"
          to="/account/settings">
          <div
            class="account-bar__tab">
            Settings
          </div>
        </router-link>
      </b-container>
    </div>

    <div class="d-none p-2">
      <b-button
        v-b-modal.mobile-menu
        variant="light"
        block
        squared>
        <font-awesome-icon
          class="mr-2"
          :icon="['fas', 'bars']"/>
        My Account
      </b-button>
    </div>

    <b-modal
      id="mobile-menu" title="My Account"
      hide-footer
      hide-header-close>
      <b-list-group>
        <b-list-group-item>
          <router-link
            to="/account/listings"
            @click.native="$bvModal.hide('mobile-menu')">
            My Listings
          </router-link>
        </b-list-group-item>
        <b-list-group-item>
          <router-link
            to="/account/purchases"
            @click.native="$bvModal.hide('mobile-menu')">
            Buying and Selling
          </router-link>
        </b-list-group-item>
        <b-list-group-item>
          <router-link
            to="/account/billing-history"
            @click.native="$bvModal.hide('mobile-menu')">
            Billing History
          </router-link>
        </b-list-group-item>
        <b-list-group-item>
          <router-link
            to="/account/profile"
            @click.native="$bvModal.hide('mobile-menu')">
            Profile
          </router-link>
        </b-list-group-item>
        <b-list-group-item>
          <router-link
            to="/account/settings"
            @click.native="$bvModal.hide('mobile-menu')">
            Settings
          </router-link>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AccountBar',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('Authentication', [
      'isAdmin',
    ]),
    ...mapGetters('Favorites', [
      'favoritesCount',
    ]),
    ...mapGetters('Messages', [
      'unreadCount',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.account-bar {
  background-color: #78c1e1;
  color: #ffffff;
  overflow-x: scroll;
}

.account-bar__tab {
  display: flex;
  align-items: center;
  height: 50px;
  white-space: nowrap;
}

.account-bar__link {
  cursor: pointer;
  margin-right: 20px;

  &.router-link-active {
    .account-bar__tab {
      border-bottom: 3px solid #fff;
      font-weight: bold;
    }
  }

  &.no-active {
    .account-bar__tab {
      border-bottom: none!important;
      font-weight: inherit!important;
    }
  }
}
</style>
